import type { EditorState } from '../store/editorState';

const isEnabled = (state: EditorState) => state.schoolMode.enabled;
const shouldEnableAIFeatures = (state: EditorState) =>
  !state.schoolMode.enabled || state.schoolMode.aiFeaturesAllowed;

export { isEnabled, shouldEnableAIFeatures };
